import type { Profile, IProfileRepository } from '@knownow/domain'
import { NotFoundError } from '@knownow/domain'

export class GetProfileUseCase {
  constructor(private readonly profileRepo: IProfileRepository) {}

  async execute(userId: string): Promise<Profile | null> {
    try {
      return await this.profileRepo.getByUserId(userId)
    } catch (err) {
      if (err instanceof NotFoundError) return null
      throw err
    }
  }
}
